/* =========================================================
   PREMIUM MOBILE MENU — comportement
   - Accordéon (un seul ouvert à la fois)
   - Ouverture/fermeture fluide
   - Focus trap léger + ESC
   - Lock scroll body
   - Compatible thèmes : Dawn + noma + autres
   ========================================================= */

(function () {
  const menu = document.getElementById('PremiumMenu');
  if (!menu) return;

  const drawer = menu.querySelector('.premium-menu__drawer');
  const rows = menu.querySelectorAll('.premium-menu__row[aria-controls]');
  const closers = menu.querySelectorAll('[data-premium-close]');

  /* Sélecteurs des boutons hamburger à intercepter (largement compatibles) */
  const TRIGGER_SELECTOR = [
    '[data-premium-open]',
    '.menu-toggle',
    '.site-header__icon.menu-toggle',
    '.header__icon--menu',
    'button[aria-label="Menu"]',
    'button[aria-label="menu"]',
    'menu-drawer > details > summary'
  ].join(',');

  /* Sélecteurs des menus natifs à neutraliser pour éviter doubles ouvertures */
  const NATIVE_MENUS = [
    '.mobile-menu',
    '.site-header__mobile-menu',
    'menu-drawer'
  ];

  /* -------- Ouverture / fermeture -------- */
  function openMenu() {
    // Si un menu natif s'est ouvert, on le ferme et on neutralise visuellement
    NATIVE_MENUS.forEach(sel => {
      document.querySelectorAll(sel).forEach(el => {
        el.classList.remove('is-open', 'is-active', 'is-visible', 'open');
        el.removeAttribute('open');
      });
    });

    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    if (window.navigator.vibrate) window.navigator.vibrate(8);
    setTimeout(() => drawer && drawer.focus(), 50);
  }

  function closeMenu() {
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    rows.forEach(r => collapse(r));
  }

  /* -------- Accordéon -------- */
  function expand(row) {
    const panel = document.getElementById(row.getAttribute('aria-controls'));
    if (!panel) return;
    row.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    requestAnimationFrame(() => {
      panel.style.maxHeight = panel.scrollHeight + 'px';
    });
  }

  function collapse(row) {
    const panel = document.getElementById(row.getAttribute('aria-controls'));
    if (!panel) return;
    row.setAttribute('aria-expanded', 'false');
    panel.style.maxHeight = '0px';
    panel.addEventListener('transitionend', function handler(e) {
      if (e.propertyName === 'max-height') {
        panel.hidden = true;
        panel.removeEventListener('transitionend', handler);
      }
    });
  }

  rows.forEach(row => {
    row.addEventListener('click', () => {
      const isOpen = row.getAttribute('aria-expanded') === 'true';
      rows.forEach(r => { if (r !== row) collapse(r); });
      isOpen ? collapse(row) : expand(row);
    });
  });

  /* -------- Triggers de fermeture -------- */
  closers.forEach(c => c.addEventListener('click', closeMenu));

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && menu.classList.contains('is-open')) closeMenu();
  });

  /* -------- API publique pour le bouton hamburger -------- */
  window.PremiumMenu = { open: openMenu, close: closeMenu };

  /* -------- Hook automatique sur tout bouton hamburger détecté -------- */
  /* On utilise la phase de capture (true) pour court-circuiter le script natif du thème */
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest(TRIGGER_SELECTOR);
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation && e.stopImmediatePropagation();
    openMenu();
  }, true);
})();
